import { VariantsData } from "../../../constants/variantConstants";
import React from "react";

const RenderVariantComponent = ({ keyId, attr, handleSave, varianData, ...props }) => {
  const Component = varianData ? varianData?.[keyId]?.Component : VariantsData?.[keyId]?.Component;
  return Component ? (
    <Component attr={attr} handleSave={handleSave} {...props} />
  ) : (
    <></>
  );
};

export default RenderVariantComponent;
